import { HStack, Text } from '@chakra-ui/react';
import CustomTitle from '@components/common/CustomTitle';
import { useAppSelector } from '@hooks/redux.hooks';
import { selectSituationTime } from '@redux/situation/situation.selectors';
import { format } from 'date-fns';
import { FormattedMessage } from 'react-intl';
type Props = {
  replayMode: boolean;
};

export default function CameraControlTitle({ replayMode }: Readonly<Props>) {
  const currentSituationTime = useAppSelector((state) => selectSituationTime(state, replayMode));

  return (
    <CustomTitle>
      <>
        <Text fontWeight="medium" textStyle="md" color={replayMode ? 'skyBlue' : 'red'} lineClamp={1} userSelect="none">
          <FormattedMessage id={replayMode ? 'cameras.replay' : 'cameras.live'} />
        </Text>
        {currentSituationTime && (
          <>
            <HStack gap={0}>
              <Text textStyle="md" fontWeight="medium" color="neutral.200">
                {format(new Date(currentSituationTime), 'HH:mm')}
              </Text>
              <Text textStyle="md" color="neutral.300">
                {format(new Date(currentSituationTime), ':ss')}
              </Text>
            </HStack>
            <Text textStyle="md" color="neutral.200">
              {format(new Date(currentSituationTime), 'dd/MM/yyyy')}
            </Text>
          </>
        )}
      </>
    </CustomTitle>
  );
}
